import { useGlobalConfig }                                  from "context/GlobalContext";
import { useEffect, useState 
       }                                                    from "react"
import styles                                               from './login.module.scss';
import Box                                                  from "@mui/material/Box";
import { Button, 
         styled, 
         ThemeProvider, 
         Typography 
       }                                                    from "@mui/material"
import logo                                                 from '../../../assets/img/bidgely.png';
import Checkbox                                             from '@mui/material/Checkbox';
import FormControlLabel                                     from '@mui/material/FormControlLabel';
import FormLabel                                            from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import React from "react";
import { getTheme } from "layouts/Theme/theme";
import { useThemeMode } from 'context/ThemeContext';
import { SessionApis } from "apis/sessionAPI";
import { useLocation } from "react-router";

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: '100dvh',
  minHeight: '100%',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export const LoginComponent = () => {
  
  const { rc } = useGlobalConfig();
  const { mode } = useThemeMode();
  const theme = React.useMemo(() => getTheme(rc, mode), [rc, mode]);
  const location = useLocation() as any;
 
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [errorMsg, setErrorMsg] = useState('')
  const initErrorFromGuard = location?.state?.initError ? String(location.state.initError) : '';

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    
    setErrorMsg('')
    event.preventDefault();

    if (emailError || passwordError) {
      return;
    }
    const data = new FormData(event.currentTarget);

    setLoading(true)
    const loginResp = await SessionApis.login(rc, 
        data.get('email') as string, 
        data.get('password') as string)

    if (loginResp.error) {
      if (loginResp.error.message) {
        setErrorMsg(loginResp.error.message)
      } else {
        setErrorMsg(JSON.stringify(loginResp.error))
      }
      setLoading(false)
      
    } else {
      const errorMsg = await rc.session.init(loginResp.data)
      if (errorMsg) {
        setErrorMsg(errorMsg)
        setLoading(false)
      } else {
        rc.uiRouter.navigateToHome()
      }
    }
  };

  const validateInputs = () => {
    const email = document.getElementById('email') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;

    let isValid = true;

    if (!email.value) {
      setEmailError(true);
      setEmailErrorMessage('Please enter a valid username.');
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!password.value) {
      setPasswordError(true);
      setPasswordErrorMessage('Password must be at least 6 characters long.');
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }

    return isValid;
  };

  useEffect(() => {
    if (rc.session.isUserLoggedIn()) {
      rc.uiRouter.navigateToHome()
    }
  })

  return(

    <ThemeProvider theme={theme}>
      
      <SignInContainer direction="column" justifyContent="space-between">
        
        <Card variant="outlined">
        <img className={styles.logo} src={logo} alt="Bidgely"/>
          <Typography
            variant="bglTitle3"
          >
            Login
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel sx={{ textAlign : 'left'}} htmlFor="email">Username</FormLabel>
              <TextField
                error={emailError}
                helperText={emailErrorMessage}
                id="email"
                type="email"
                name="email"
                placeholder="Enter your username"
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControl>
              <FormLabel sx={{ textAlign : 'left'}} htmlFor="password">Password</FormLabel>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                required
                fullWidth
                variant="outlined"
                color={passwordError ? 'error' : 'primary'}
              />
            </FormControl>
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              loading={loading}
              onClick={validateInputs}
            >
              Sign in
            </Button>
            <Typography
                variant="bglSubtitle3"
                sx={{
                  color: 'red'
                }}
              >
                {errorMsg || initErrorFromGuard}
          </Typography>
          </Box>
          
        </Card>
      </SignInContainer>
    
    </ThemeProvider>
  )
}